import { useState, useMemo } from 'react'

/**
 * useMultiState Hook
 *
 * Custom hook for managing multiple state values in a single state object
 * Similar to React's useState but for objects, with automatic merging
 *
 * @param {Object|Function} initState - Initial state object or function that returns initial state
 * @returns {Array} [state, updateState] - Current state and update function
 */
export const useMultiState = (initState) => {
  const [state, setState] = useState(initState)

  const updateState = useMemo(
    () => (newState) => {
      if (typeof newState === 'function') {
        setState((prevState) => ({ ...prevState, ...newState(prevState) }))
      } else {
        setState((prevState) => ({ ...prevState, ...newState }))
      }
    },
    [setState]
  )

  return [state, updateState]
}
